import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Customers({ children }) {
  return (
    <div>
      <CustomPageHeader icon='address-book' text='Customers' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Customers/index.js